import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Icon from './Icon';
import '../css/sort-menu.css';

const CustomSelect = ({ value, options, onChange, minWidth = '160px', hasActiveFilter = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const selectedOption = options.find(opt => opt.value === value) || options[0];

  const handleSelect = (val) => {
    onChange(val);
    setIsOpen(false);
  };

  const isPercentWidth = typeof minWidth === 'string' && minWidth.includes('%');

  return (
    <div className="sort-menu-wrapper" ref={containerRef}>
      <button
        type="button"
        className={`sort-menu-button${hasActiveFilter ? ' filter-active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        style={{ minWidth, width: isPercentWidth ? minWidth : undefined, justifyContent: 'space-between' }}
      >
        <span className="sort-menu-label" style={{ textAlign: 'left', display: 'flex', alignItems: 'center', gap: '8px' }}>
          {selectedOption.icon && <Icon name={selectedOption.icon} size={16} />}
          {selectedOption.label}
        </span>
        <span className="sort-menu-arrow">
          <Icon
            name="chevron-down"
            size={12}
            className={`expand-icon ${isOpen ? 'open' : ''}`}
          />
        </span>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="sort-menu-dropdown"
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 4 }}
            transition={{ duration: 0.15, ease: 'easeOut' }}
            style={{ minWidth: '100%', maxWidth: 'min(320px, calc(100vw - 2rem))', padding: '8px', left: 0, right: 'auto', zIndex: 1000 }}
          >
            <div className="sort-menu-options" style={{ gap: '6px' }}>
              {options.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  className={`sort-menu-option ${value === option.value ? 'active' : ''}`}
                  onClick={() => handleSelect(option.value)}
                  style={{ 
                    justifyContent: 'flex-start', 
                    padding: '10px 12px',
                    border: '1px solid var(--border-color)',
                    background: value === option.value ? 'var(--nav-active-bg, rgba(59, 130, 246, 0.05))' : 'var(--bg-secondary)',
                    minWidth: 0
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {option.icon && <Icon name={option.icon} size={16} style={{ opacity: 0.8 }} />}
                    <span className="sort-menu-option-label" style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{option.label}</span>
                  </div>
                  {value === option.value && (
                    <span className="sort-menu-option-check" style={{ marginLeft: '12px' }}>
                      <Icon name="check" size={14} />
                    </span>
                  )}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CustomSelect;
